/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { MdMenu, MdArrowBackIosNew, MdExitToApp } from "react-icons/md";
import { Sidebar } from "./sidebar";
import {
  Navbar, NavGroup, NavTitle, BtnIcon,
  SidebarOverlay, SidebarContainer, SidebarHeader, SidebarSub,
  SidebarNav, SidebarLink, SidebarFooter,
} from "./styled";
import logoImg from "../../assets/images/logo_completa_branca.png";
import useAuth from "../../hooks/useAuth";

export default function Menu({ transparent, title }) {
  const [sidebar, setSidebar] = useState(false);
  const [exitBtn, setExitBtn] = useState(sessionStorage.getItem('botao'));
  const [exibeMenu, setExibeMenu] = useState(sessionStorage.getItem('token'));

  let navigate = useNavigate();
  const { pathname } = useLocation();
  const { signout } = useAuth();

  const openSidebar = useCallback(() => {
    document.body.classList.add('no-scroll');
    setSidebar(true);
  }, []);

  const closeSidebar = useCallback(() => {
    document.body.classList.remove('no-scroll');
    setSidebar(false);
  }, []);

  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') closeSidebar(); };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, []);

  useEffect(() => {
    setExitBtn(sessionStorage.getItem('botao'));
    setExibeMenu(sessionStorage.getItem('token'));
  });

  if (!exibeMenu || pathname === '/login') return null;

  return (
    <>
      <Navbar transparent={transparent}>
        <NavGroup>
          <BtnIcon
            onClick={openSidebar}
            aria-label="Abrir menu"
            elevated={transparent ? 1 : 0}
          >
            <MdMenu />
          </BtnIcon>
          {title && <NavTitle>{title}</NavTitle>}
        </NavGroup>

        <NavGroup>
          {pathname !== "/" && (
            <BtnIcon
              outlined={transparent ? 0 : 1}
              elevated={transparent ? 1 : 0}
              onClick={() => {
                if (pathname === "/linha" || pathname === "/endereco" || pathname === "/viagens") {
                  localStorage.removeItem("BuslineShiftID");
                }
                if (pathname !== "/endereco") {
                  localStorage.removeItem("address");
                  localStorage.removeItem("addressList");
                }
                navigate(-1);
              }}
              aria-label="Voltar"
            >
              <MdArrowBackIosNew />
            </BtnIcon>
          )}
          {exitBtn === 'true' && (
            <BtnIcon
              elevated={transparent ? 1 : 0}
              outlined={transparent ? 0 : 1}
              onClick={() => { signout(); navigate('/login'); }}
              aria-label="Sair"
            >
              <MdExitToApp />
            </BtnIcon>
          )}
        </NavGroup>
      </Navbar>

      <SidebarOverlay open={sidebar} onClick={closeSidebar} />
      <SidebarContainer open={sidebar} role="navigation" aria-label="Menu principal">
        <SidebarHeader>
          <img src={logoImg} alt="SS Telemática" />
          <SidebarSub>Acompanhamento de Viagens</SidebarSub>
        </SidebarHeader>

        <SidebarNav>
          {Sidebar.map((item, index) => (
            <SidebarLink
              as={Link}
              key={index}
              to={item.path}
              active={pathname === item.path ? 1 : 0}
              onClick={() => {
                if (pathname === "/linha" || pathname === "/endereco") {
                  localStorage.removeItem("BuslineShiftID");
                }
                if (pathname === "/viagens") localStorage.removeItem("LinhaID");
                if (pathname !== "/endereco") {
                  localStorage.removeItem("address");
                  localStorage.removeItem("addressList");
                }
                closeSidebar();
              }}
            >
              {item.icon}
              <span>{item.title}</span>
            </SidebarLink>
          ))}
        </SidebarNav>

        <SidebarFooter>v2.0 - SS Telemática</SidebarFooter>
      </SidebarContainer>
    </>
  );
}
